document.addEventListener("DOMContentLoaded", function () {

	document.addEventListener('click', function (event) {

		//if the load more button is clicked
		if (!event.target.matches('.playback-toggle')) return;

		let button = event.target;
		let block = button.parentNode.parentNode;

		if(block) {
			let video = block.getElementsByTagName('video')[0];
			let status = button.dataset.status ? button.dataset.status : 'playing';

			if(video && status) {

				switch(status) {
					case 'playing':
						video.pause();
						button.dataset.status = 'paused';
						break;
					default:
						video.play();
						button.dataset.status = 'playing';
						break;
				}
			}
		}
	});
});